import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "@/lib/shadcn/ui/dialog";
import { Button } from "@/lib/shadcn/ui/button";
import { Input } from "@/lib/shadcn/ui/input";
import { Label } from "@/lib/shadcn/ui/label";

interface SaveViewModalProps {
    show: boolean;
    viewName: string;
    handleClose: () => void;
    handleSaveView: (viewName: string) => void;
}

const SaveViewModal: React.FC<SaveViewModalProps> = ({ show, viewName, handleClose, handleSaveView }) => {
    const [name, setName] = useState(viewName);
    const [errorMessage, setErrorMessage] = useState("");

    const onSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        const disallowedValues = ["Default"];
        if (disallowedValues.includes(name)) {
            setErrorMessage("This view name is not allowed.");
            return;
        }
        handleSaveView(name);
        handleCloseModal();
    };

    useEffect(() => {
        setName(viewName);
    }, [viewName]);

    const handleCloseModal = () => {
        setErrorMessage("");
        handleClose();
    };

    return (
        <Dialog open={show} onOpenChange={handleCloseModal}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Save View</DialogTitle>
                    <DialogDescription>Name this view to save its current columns and filters.</DialogDescription>
                </DialogHeader>
                <form onSubmit={onSubmit}>
                    <div className="grid gap-4 py-4">
                        <div className="grid gap-2">
                            <Label htmlFor="viewName">View Name</Label>
                            <div className="space-y-1">
                                <Input
                                    id="viewName"
                                    value={name}
                                    onChange={(event) => setName(event.target.value)}
                                    required
                                    aria-invalid={!!errorMessage}
                                    className={errorMessage ? "border-red-500" : ""}
                                />
                                {errorMessage && <p className="text-sm text-red-500">{errorMessage}</p>}
                            </div>
                        </div>
                    </div>
                    <DialogFooter>
                        <Button type="button" variant="secondary" onClick={handleCloseModal}>
                            Cancel
                        </Button>
                        <Button type="submit" variant="volt">
                            Save
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default SaveViewModal;
